import React, {Component} from 'react'
import Calculator from '../../Calculator.js'
import './calculator.scss'
import FormattedInputField from '../../../sharedComponents/formattedInputField.component.jsx'
import Icon from "../../icon/icon.component.jsx"

class ModalSearchCalculatorInput extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            calculator: null,
            assembly: null,
            vars: {},
        }
        this.onChange = this.props.onChange|| function() {}
    }

    componentDidMount() {
        this.setState({
            calculator: this.props.value,
            assembly: this.props.assembly || null,
            vars: this.props.vars || {},
        })
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            calculator: nextProps.value,
            assembly: nextProps.assembly || null,
        })
    }

    calculate() {
        const results = this.state.calculator.attributes.formulas.map(formula => {
            const calculator = new Calculator(formula.attributes.formula)
            return {
                partId: formula.attributes.partId,
                result: calculator.execute(this.state.vars)
            }
        })
        this.onChange({
            results: results,
            values: this.state.vars
        })

    }

    render() {
        if (!this.state.calculator) {
            return <div />
        }
        return <div className="row calculator pt-3 pb-1 mb-2">
            <div className="col-1">
                <span className="">
                    <Icon className={"calculator-icon"} value={"calculator"}/>
                </span>
            </div>
            <div className="col-11">
                {this.state.calculator.attributes.terms.map(term =>
                    <div className="row" key={term.id}>
                        <div className="col-12">
                            <div className="form-group form-row">
                                <label className="col-5 col-form-label text-align-right">
                                    {term.attributes.name}
                                </label>
                                <div className="col-7">
                                    <FormattedInputField  type="text"
                                                          name={term.attributes.variableName}
                                                          className="form-control"
                                                          placeholder="0.00"
                                                         valueType="decimal"
                                                         value={this.state.vars[term.attributes.variableName]}
                                                         onValueChange={(newValue) => {
                                                             let newVars = Object.assign({}, this.state.vars)
                                                             newVars[term.attributes.variableName] = newValue
                                                             this.setState({vars: newVars}, () => this.calculate())
                                                         }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    }
}

export default ModalSearchCalculatorInput





// WEBPACK FOOTER //
// ./src/common/pricing/add-item-modal/calculator.component.jsx